import React from "react";
import { ResponsiveContainer, LineChart, Line, YAxis } from "recharts";

/**
 * Compact sparkline for hero KPI cards.
 * Props:
 *   data: [{ v: number }]  — one value per point
 *   color: hex string      — line & gradient stroke
 *   height: px             — default 32
 */
export default function Sparkline({ data = [], color = "#1E2A5A", height = 32, testid }) {
    if (!Array.isArray(data) || data.length === 0) {
        return <div style={{ height }} className="w-full opacity-30" data-testid={testid} />;
    }
    return (
        <div style={{ height, width: "100%", minWidth: 48 }} data-testid={testid}>
            <ResponsiveContainer width="100%" height="100%" minWidth={48} minHeight={height}>
                <LineChart data={data} margin={{ top: 2, bottom: 2, left: 0, right: 0 }}>
                    <YAxis hide domain={["auto", "auto"]} />
                    <Line
                        type="monotone"
                        dataKey="v"
                        stroke={color}
                        strokeWidth={1.75}
                        dot={false}
                        isAnimationActive={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
